<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [imageURL]="
              customer.coverUrl
                ? customer.coverUrl
                : '/assets/images/default_avatar.jpg'
            "
            [mode]="'avatar'"
            (click)="selectDetail()"
          ></ngx-view-user-display>
        </div>

        <div>
          <a
            *ngIf="customer?.fullName"
            class="text-body link"
            (click)="selectDetail()"
          >
            <h6>{{ customer.fullName }}</h6>
          </a>

          <div *ngIf="customer.tags?.length > 0" class="text-link">
            <ngx-view-tags
              [tags]="customer.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <!-- <button
        *ngIf="mode !== 'dept'"
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + customer.id"
        (click)="loadButtonAction(customer)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button> -->

      <h6 *ngIf="mode === 'dept'">
        <span class="text-hint">Hiện tại $:</span>
        <span class="text-primary">
          / Bán: {{ customer.saleAmount | number }}
        </span>
        <span class="text-success">
          / Trả: {{ customer.paidAmount | number }}
        </span>
        <span class="text-warning">
          / Nợ: {{ customer.debitAmount | number }}
        </span>
      </h6>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="content">
      <a
        *ngIf="customer?.mobile"
        href="tel:{{ customer.mobile }}"
        class="text-primary link"
      >
        <nb-icon icon="phone-call-outline"></nb-icon> {{ customer.mobile }}
      </a>

      <a
        *ngIf="customer?.email"
        href="mailto:{{ customer.email }}"
        class="text-primary link"
      >
        <nb-icon icon="email-outline"></nb-icon> {{ customer.email }}
      </a>
    </div>

    <div class="content">
      <a *ngIf="!isMore" (click)="loadContent(true)" class="link text-link">
        <nb-icon icon="chevron-down-outline"></nb-icon>
      </a>

      <a
        *ngIf="
          mode === 'dept' &&
          shopService.shop.isArchived &&
          shopService.shop.shopIdArchived &&
          customer.shopIdArchived &&
          customer.archivedId !== ''
        "
        (click)="archiveData()"
        class="link text-link"
      >
        <nb-icon icon="calendar-outline"></nb-icon>
        Xem dữ liệu cũ
      </a>
    </div>

    <nb-card *ngIf="isMore">
      <nb-card-body>
        <ul class="detail">
          <li *ngIf="customer.gender">
            {{ "common.gender" | translate }}:
            <span class="text-hint"> {{ customer.gender }}</span>
          </li>
          <li *ngIf="customer.dob">
            {{ "person.dob" | translate }}:
            <span class="text-hint">
              {{ customer.dob | date: "dd/MM/yyyy" }}</span
            >
          </li>
          <li *ngIf="customer.cardId">
            CMND: <span class="text-hint"> {{ customer.cardId }}</span>
          </li>
          <li *ngIf="customer.tax">
            {{ "person.tax" | translate }}:
            <span class="text-hint"> {{ customer.tax }}</span>
          </li>
          <li *ngIf="customer.address">
            {{ "common.address" | translate }}:<span class="text-hint">
              {{ customer.address }}
            </span>
          </li>
          <li *ngIf="customer.description">
            {{ "common.note" | translate }}:
            <span class="text-hint" style="white-space: pre">{{
              customer.description
            }}</span>
          </li>
          <li *ngIf="customer.assignBy && customer.assignName">
            Quản lý:
            <span class="text-hint" style="white-space: pre">{{
              customer.assignName
            }}</span>
          </li>
        </ul>

        <ngx-view-gallery
          *ngIf="customer.imagesUrl?.length > 0"
          [imagesUrl]="customer.imagesUrl"
        >
        </ngx-view-gallery>
      </nb-card-body>
    </nb-card>

    <div class="content">
      <a *ngIf="isMore" (click)="loadContent(false)" class="link text-link">
        <nb-icon icon="chevron-up-outline"></nb-icon>
      </a>

      <div *ngIf="isMore" class="button-action">
        <button
          *ngIf="user.moderator"
          nbButton
          ghost
          status="danger"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="delete(customer)"
        >
          <nb-icon icon="trash-2-outline"></nb-icon>
        </button>

        <button
          nbButton
          ghost
          status="info"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="edit(customer)"
        >
          <nb-icon icon="edit-2-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>

  <!-- <nb-card-footer>
    <div class="button-actions">
      <button
        *ngIf="mode != 'customer'"
        nbButton
        ghost
        status="success"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="createHistory(customer)"
      >
        <nb-icon icon="file-text-outline"></nb-icon>
        <span *ngIf="!isMobile"> Tạo nhật ký</span>
        <span *ngIf="isMobile"> Nhật ký</span>
      </button>

      <button
        *ngIf="mode != 'customer'"
        nbButton
        ghost
        size="small"
        status="info"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="viewHistory(customer)"
      >
        <nb-icon icon="calendar-outline"></nb-icon>
        <span *ngIf="!isMobile"> Xem lịch sử</span>
        <span *ngIf="isMobile"> Lịch sử</span>
      </button>
    </div>
  </nb-card-footer> -->
</nb-card>
